import _compact from "lodash/compact";
import _nth from "lodash/nth";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateField, DateTimeField } from '@nextiva/next-ui';
import ColumnFilter from "../ColumnFilter";
import { mapNullValues, mapEmptyOperator } from "../dataMappers/incoming";
import { formatNullValues, formatEmptyOperator } from "../dataMappers/outgoing";

var DateColumn =
/*#__PURE__*/
function (_Component) {
  _inherits(DateColumn, _Component);

  function DateColumn() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DateColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DateColumn.__proto__ || Object.getPrototypeOf(DateColumn)).call.apply(_ref, [this].concat(args))), _initialiseProps.call(_assertThisInitialized(_this)), _temp));
  }

  _createClass(DateColumn, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          operatorOptions = _props.operatorOptions,
          onOperatorChange = _props.onOperatorChange,
          operator = _props.operator,
          onSelectFocus = _props.onSelectFocus;
      return React.createElement(ColumnFilter, {
        onOperatorChange: onOperatorChange,
        options: operatorOptions,
        operator: operator,
        onFocus: onSelectFocus
      }, this.renderPicker());
    }
  }]);

  return DateColumn;
}(Component);

Object.defineProperty(DateColumn, "defaultOperator", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return 'eq';
  }
});
Object.defineProperty(DateColumn, "getOperatorOptions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(_ref2) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? 'Date' : _ref2$title;
    return [{
      value: 'eq',
      label: "".concat(title, " is")
    }, {
      value: 'lt',
      label: "".concat(title, " is before")
    }, {
      value: 'gte',
      label: "".concat(title, " is after")
    }, {
      value: 'between',
      label: "".concat(title, " is between")
    }, {
      value: 'empty',
      label: 'Is Empty'
    }, {
      value: 'notEmpty',
      label: 'Is not Empty'
    }];
  }
});
Object.defineProperty(DateColumn, "defaultDateFormat", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return 'MM/DD/YYYY';
  }
});
Object.defineProperty(DateColumn, "defaultDateTimeFormat", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return 'MM/DD/YYYY HH:mm A';
  }
});
Object.defineProperty(DateColumn, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    values: PropTypes.array,
    operator: PropTypes.string,
    onOperatorChange: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    title: PropTypes.string,
    format: PropTypes.string,
    withTime: PropTypes.bool,
    isNullTypeOperator: PropTypes.bool,
    onSelectFocus: PropTypes.func,
    columnDataOptions: PropTypes.object,
    timeIntervals: PropTypes.number
  }
});
Object.defineProperty(DateColumn, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    format: DateColumn.defaultDateFormat(),
    withTime: false,
    timeIntervals: 15
  }
});
Object.defineProperty(DateColumn, "getFormatFromAdditionalOptions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(props) {
    return ((props || {}).columnDataOptions || {}).dateFormat;
  }
});
Object.defineProperty(DateColumn, "getDateFormat", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(props) {
    var defaultDateFormat = props.withTime ? DateColumn.defaultDateTimeFormat() : DateColumn.defaultDateFormat();
    return DateColumn.getFormatFromAdditionalOptions(props) || defaultDateFormat;
  }
});
Object.defineProperty(DateColumn, "mapIncomingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return mapEmptyOperator(mapNullValues.apply(void 0, arguments));
  }
});
Object.defineProperty(DateColumn, "mapOutgoingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    var _formatEmptyOperator = formatEmptyOperator(formatNullValues.apply(void 0, arguments)),
        operator = _formatEmptyOperator.operator,
        values = _formatEmptyOperator.values;

    var startDate = _nth(values, 0);

    var endDate = _nth(values, 1);

    var additionalData = {
      dateFormat: DateColumn.getFormatFromAdditionalOptions.apply(DateColumn, arguments)
    };

    if (operator === 'between') {
      if (startDate && !endDate) {
        return _objectSpread({
          operator: 'gte',
          values: [startDate]
        }, additionalData);
      } else if (!startDate && endDate) {
        return _objectSpread({
          operator: 'lt',
          values: [endDate]
        }, additionalData);
      }
    }

    return _objectSpread({
      operator: operator,
      values: values
    }, additionalData);
  }
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, "getStartValue", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(dateString) {
      var withTime = _this2.props.withTime;
      var dateFormat = DateColumn.getDateFormat(_this2.props);
      return moment(dateString, dateFormat).subtract(1, withTime ? 'hours' : 'days').format(dateFormat);
    }
  });
  Object.defineProperty(this, "getEndValue", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(dateString) {
      var withTime = _this2.props.withTime;
      var dateFormat = DateColumn.getDateFormat(_this2.props);
      return moment(dateString, dateFormat).add(1, withTime ? 'hours' : 'days').format(dateFormat);
    }
  });
  Object.defineProperty(this, "handleFilterChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(type) {
      return function (value) {
        var nextValues = [value];
        var values = _this2.props.values;

        if (type === 'end') {
          nextValues = [_nth(values, 0), value];

          if (!_this2.isValidEnd(value)) {
            nextValues[0] = _this2.getStartValue(value);
            nextValues[1] = value;
          }
        } else if (type === 'start') {
          nextValues = [value, _nth(values, 1)];

          if (!_this2.isValidStart(value)) {
            nextValues[0] = value;
            nextValues[1] = _this2.getEndValue(value);
          } // workaround due to react-datepicker firing onChange on date select
          // before time is selected. Otherwise due to midnight being set as time
          // by default, startDate jumps to 23:00 of the previous day.


          if (!_nth(values, 1)) {
            nextValues[1] = _this2.getEndValue(value);
          }
        }

        var newValues = !_compact(nextValues).length ? undefined : nextValues;

        _this2.props.onFilterChange(newValues);
      };
    }
  });
  Object.defineProperty(this, "isValidStart", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_value) {
      if (!_value) {
        return true;
      }

      var values = _this2.props.values; // if end value is not set the operator remains valid

      if (!_nth(values, 1)) {
        return true;
      }

      var dateFormat = DateColumn.getDateFormat(_this2.props);
      var startDate = moment(_value, dateFormat).valueOf();
      var endDate = moment(_nth(values, 1), dateFormat).valueOf();
      return endDate > startDate;
    }
  });
  Object.defineProperty(this, "isValidEnd", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      if (!_value2) {
        return true;
      }

      var values = _this2.props.values; // if start value is not set the operator remains valid

      if (!_nth(values, 0)) {
        return true;
      }

      var dateFormat = DateColumn.getDateFormat(_this2.props);
      var startDate = moment(_nth(values, 0), dateFormat).valueOf();
      var endDate = moment(_value2, dateFormat).valueOf();
      return endDate > startDate;
    }
  });
  Object.defineProperty(this, "renderRangeField", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      var _this2$props = _this2.props,
          withTime = _this2$props.withTime,
          onKeyDown = _this2$props.onKeyDown;
      var Component = withTime ? DateTimeField : DateField;
      var dateFormat = DateColumn.getDateFormat(_this2.props);
      return React.createElement("div", {
        className: "nx-filter-column__search"
      }, React.createElement(Component, {
        placeholderText: "Start date (".concat(dateFormat, ")"),
        value: _nth(values, 0),
        onChange: _this2.handleFilterChange('start'),
        onKeyDown: onKeyDown,
        displayFormat: dateFormat,
        format: dateFormat
      }), React.createElement(Component, {
        placeholderText: "End date (".concat(dateFormat, ")"),
        value: _nth(values, 1),
        onChange: _this2.handleFilterChange('end'),
        onKeyDown: onKeyDown,
        displayFormat: dateFormat,
        format: dateFormat
      }));
    }
  });
  Object.defineProperty(this, "renderSingleField", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      var _this2$props2 = _this2.props,
          withTime = _this2$props2.withTime,
          onKeyDown = _this2$props2.onKeyDown;
      var Component = withTime ? DateTimeField : DateField;

      var value = _nth(values, 0) || _nth(values, 1);

      var dateFormat = DateColumn.getDateFormat(_this2.props);
      return React.createElement("div", {
        className: "nx-filter-column__search"
      }, React.createElement(Component, {
        placeholderText: "Select Date",
        value: value,
        onChange: _this2.handleFilterChange(),
        onKeyDown: onKeyDown,
        displayFormat: dateFormat,
        format: dateFormat,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: 'viewport'
          }
        }
      }));
    }
  });
  Object.defineProperty(this, "renderPicker", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this2$props3 = _this2.props,
          operator = _this2$props3.operator,
          values = _this2$props3.values;

      if (_this2.props.isNullTypeOperator) {
        return null;
      } else if (operator === 'between') {
        return _this2.renderRangeField(values);
      }

      return _this2.renderSingleField(values);
    }
  });
};

export default DateColumn;